import React from 'react';
import queryString from 'query-string';
import Navigation from 'Components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import FrequentAddressEditForm from 'Components/FrequentAddressEditForm';
import { frequentAddressService, userService } from 'Services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';

class FrequentAddressPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            isNew: false,
            edit_address: null,
            suburbs: null
        };

        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    fetchData = (address_id) => {

        if (address_id === "-1") {

            var selectedAccount = null;

            if (this.props.router.location && this.props.router.location.state) {
                selectedAccount = this.props.router.location.state.selectedAccount;
            }

            this.setState({
                loaded: true,
                isNew: true,
                edit_address: {
                    id: '',
                    account: selectedAccount,
                    contact: '',
                    company: '',
                    phone: '',
                    address1: '',
                    address2: '',
                    suburb: '',
                    customer_key: ''
                }
                });
            
            return;
        }

        frequentAddressService.getAddress(address_id)
            .then(response => {
                if (response.status === 200) {
                    var address = response.data;

                    this.setState({
                        loaded: true,
                        isNew: false,
                        edit_address: {
                            id: address.id,
                            account: address.account,
                            contact: address.contact,
                            company: address.company,
                            phone: address.phone,
                            address1: address.address1,
                            address2: address.address2,
                            suburb: address.suburb,
                            customer_key: address.key
                        }
                    });
                }
            })
            .catch(error => console.log(error));
    }

    componentDidMount() {

        userService.getLocations()
            .then(response => {

                var suburbs = response;

                this.setState({
                    suburbs: suburbs
                });

                const values = queryString.parse(this.props.router.location.search);
                this.fetchData(values.id);
            })
            .catch(error => {
                console.log(error);
            });

        
    }

    onFormSubmit(formData) {
        var data = {};

        formData.forEach((value, key) => {
            data[key] = value;
        });

        var navigate = this.props.router.navigate;

        frequentAddressService.submitAddress(data)
            .then(response => {
                if (response.status === 200) {
                    navigate('/admin_addresses');
                } else if (response.status === 201) {
                    this.setState({
                        isNew: false
                    });
                    navigate('/admin_addresses');
                } else {
                    if (response.message !== undefined && response.message !== null)
                        alert(response.message);
                    console.log(response);
                }
            })
            .catch(error => {
                console.log(error);
                var errorMessage = error.Message;

                if (error.ModelState) {
                    for (var key in error.ModelState) {
                        errorMessage += '\n' + error.ModelState[key];
                    }
                }
                alert(errorMessage || error);
            });
    }

    render() {

        if (!this.state.loaded)
            return (<LoadingPageContent />);

        var accountOptions = null;

        if (this.props.authenticatedUser) {
            accountOptions = this.props.authenticatedUser.accounts;
        }

        return (
            <div id="frequentAddress">
                <Navigation active="admin" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">{this.state.isNew ? "Add" : "Edit"} Frequent Address</div>
                    </div>
                    <div className="padding-tb10" />
                    <div className="row">
                        <div className="col-sm-12">
                            <FrequentAddressEditForm
                                isNew={this.state.isNew}
                                accountOptions={accountOptions}
                                suburbs={this.state.suburbs}
                                edit_address={this.state.edit_address}
                                onFormSubmit={this.onFormSubmit} />
                        </div>
                    </div>
                    
                </div>
            </div>
            );
    }
}

const DecoratedFrequentAddressPage = withAuthenticatedUser(withRouter(FrequentAddressPage));

export { DecoratedFrequentAddressPage as FrequentAddressPage };
